export const colors = {
  brand: {
    navy500: "#0F1F3D",
    navy50: "#E9EDF5",
    navy100: "#C9D3E4",
    red500: "#AF1F24",
    red50: "#FBEAEA",
    red100: "#F4C9CB",
  },
  state: {
    danger: "#C8232C",
    warning: "#E87722",
    success: "#0E7C6E",
    info: "#1565C0",
    pending: "#E0B429",
  },
  neutral: {
    white: "#FFFFFF",
    50: "#F4F5F7",
    100: "#F4F5F7",
    200: "#E5E7EB",
    400: "#BFC5CE",
    600: "#6B7280",
    800: "#374151",
    900: "#1F2937",
  },
  status: {
    draft: { text: "#374151", bg: "#F4F5F7", border: "#E5E7EB" },
    pending: { text: "#9A6B00", bg: "#FFF7E0", border: "#E0B429" },
    processing: { text: "#1565C0", bg: "#EAF3FF", border: "#1565C0" },
    approved: { text: "#0E7C6E", bg: "#E7F6F3", border: "#0E7C6E" },
    paid: { text: "#0E7C6E", bg: "#E7F6F3", border: "#0E7C6E" },
    rejected: { text: "#C8232C", bg: "#FBEAEA", border: "#C8232C" },
    overdue: { text: "#AF1F24", bg: "#FBEAEA", border: "#AF1F24" },
  },
};

export default colors;
